import { useLocation } from 'react-router';
import { useSesion } from '@plataforma/web/sesion';
import { Logotipo } from '@plataforma/ui/Logo';

/** Sin sesión: se entra con la cuenta de Keycloak del lotero (código + PKCE). */
export function Entrar() {
  const { entrar } = useSesion();
  const { pathname } = useLocation();
  return (
    <div className="centro">
      <div className="entrada">
        <Logotipo tamano={40} />
        <h1>Admin Lotero</h1>
        <p className="subtitulo">Tus autos, tus costos y tu margen, en un solo lugar.</p>
        <button className="boton primario" onClick={() => void entrar(pathname)}>
          Entrar con mi cuenta
        </button>
      </div>
    </div>
  );
}
